module.exports = {"320583100":"玉山镇","320583101":"巴城镇","320583102":"周市镇","320583103":"陆家镇","320583104":"花桥镇","320583105":"淀山湖镇","320583106":"张浦镇","320583107":"周庄镇","320583108":"千灯镇","320583109":"锦溪镇","320583400":"开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320583.json
// module id = 807
// module chunks = 0